<script setup lang="ts">
import * as locales from '@nuxt/ui/locale'

const { locale } = useI18n()

const lang = computed(() => locales[locale.value].code)
const dir = computed(() => locales[locale.value].dir)

const route = useRoute();

useHead({
    title: route.meta.title as string,
    htmlAttrs: {
        lang,
        dir
    }
});

</script>

<template>
    <UApp :locale="locales[locale]">
        <NuxtLayout>
            <NuxtPage/>
        </NuxtLayout>
    </UApp>
</template>
